import { createContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import { apiConnect } from "../services/api";

export const LoginContext = createContext({});

export const LoginProvider = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkTokenInterval = setInterval(() => {
      const token = sessionStorage.getItem("connectionsToken");
      console.log("Token verificado:", token);

      if (token) {
        console.log("Token encontrado! Navegando...");
        navigate("/");
        clearInterval(checkTokenInterval);
      }
    }, 1000);

    return () => clearInterval(checkTokenInterval);
  }, []);

  useEffect(() => {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      let timeoutId = setInterval(() => {
        const currentPath = window.location.pathname;
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "route", path: currentPath })
        );
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, []);

  const handleSubmitLogin = async (data) => {
    setLoading(true);
    try {
      const response = await apiConnect.post("users/login/", data);
      sessionStorage.setItem("connectionsToken", response.data.access);
      toast.success("Login feito com Sucesso", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      navigate("/");
    } catch (error) {
      if (error.request.status === 401) {
        toast.error("Nome do Usuário invalido ou senha invalida", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.warn("😅Algo de Errado", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginContext.Provider value={{ loading, setLoading, handleSubmitLogin }}>
      <Outlet />
    </LoginContext.Provider>
  );
};
